function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { ColumnBase } from './ColumnBase';

var noop = function noop() {
  return void 0;
};

export var Column = function (_ColumnBase) {
  _inherits(Column, _ColumnBase);

  var _super = _createSuper(Column);

  function Column(manager, options, parent) {
    var _this;

    _classCallCheck(this, Column);

    _this = _super.call(this, manager, options, parent);
    _this.expectWidth = 0;
    _this.widthFixed = false;
    _this.width = 0;
    _this.renderData = options.renderData;
    _this.onRowChange = options.onRowChange || noop;
    _this.className = options.className || '';
    return _this;
  }

  _createClass(Column, [{
    key: "updateColumnOptions",
    value: function updateColumnOptions(options) {
      _get(_getPrototypeOf(Column.prototype), "updateColumnOptions", this).call(this, options);

      var _options$widthFixed = options.widthFixed,
          widthFixed = _options$widthFixed === void 0 ? false : _options$widthFixed,
          width = options.width,
          renderData = options.renderData,
          className = options.className;
      this.className = className || '';
      this.expectWidth = width;
      this.widthFixed = widthFixed;
      this.renderData = renderData;
      this.onRowChange = options.onRowChange || noop;
      this.repaint();
    }
  }, {
    key: "getExpectWidth",
    value: function getExpectWidth() {
      return this.expectWidth;
    }
  }, {
    key: "isWidthFixed",
    value: function isWidthFixed() {
      return this.widthFixed;
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.width;
    }
  }, {
    key: "setWidth",
    value: function setWidth(width) {
      if (width !== this.width) {
        this.width = width;
        this.repaint();
      }
    }
  }, {
    key: "isShow",
    value: function isShow() {
      return this.show && this.expectWidth !== 0;
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      return this.className;
    }
  }]);

  return Column;
}(ColumnBase);